<template>
    <v-menu
        v-model="open"
        :close-on-content-click="false"
        offset-y
        left
    >
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom :disabled="!!label">
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-if="label"
                        color="error"
                        :small="small"
                        outlined
                        :loading="loading"
                        v-bind="attrs"
                        v-on="menu"
                        @click.stop
                    >
                        <v-icon left>mdi-delete-outline</v-icon>{{ label }}
                    </v-btn>
                    <v-btn
                        v-else
                        icon
                        small
                        color="error"
                        :loading="loading"
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                        @click.stop
                    >
                        <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                </template>
                <span>Delete</span>
            </v-tooltip>
        </template>
        <v-card max-width="320" @click.stop>
            <v-card-title class="text-subtitle-1 font-weight-medium">{{ title }}</v-card-title>
            <v-card-text v-if="text">{{ text }}</v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text @click="open = false">Cancel</v-btn>
                <v-btn color="error" depressed @click="confirm">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>

<script>
    export default {
        name: 'DeleteButton',
        props: {
            title: {
                type: String,
                default: 'Delete this item?'
            },
            text: {
                type: String,
                default: 'This cannot be undone.'
            },
            label: {
                type: String,
                default: null
            },
            small: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                open: false
            }
        },
        methods: {
            confirm() {
                this.open = false
                this.$emit('delete-entry')
            }
        }
    }
</script>
